import KeenSlider from "keen-slider";
import { animateCardsIn } from "../../utils/animateCardsIn";
import { CardMediaController } from "../../utils/cardMediaPool";

function fillSlider(container) {
  if (!container.offsetWidth) return;
  const slides = Array.from(container.children);
  if (!slides.length) return;

  const target = container.offsetWidth * 2;
  let total = slides.reduce((sum, s) => sum + s.offsetWidth, 0);

  while (total < target) {
    slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      container.appendChild(clone);
      total += slide.offsetWidth;
    });
  }
}

export default class FreeProductsPush {
  constructor(el) {
    this.el = el;

    this.init();
  }

  init() {
    this.list = this.el.querySelector(".c-free-products-push__list");

    fillSlider(this.list);

    this.slider = new KeenSlider(this.list, {
      loop: true,
      slides: {
        perView: "auto",
        spacing: 8,
      },
    });

    this.initClickableTag();
    this.initResizeObserver();
    animateCardsIn(this.list);

    // Covers the slider list and the static mobile list; only on-screen cards
    // (and clones) borrow a player.
    this.mediaPool = new CardMediaController({
      hover: true,
      context: "product-card:free-products-push",
    });
    this.syncMedia();
  }

  syncMedia() {
    this.mediaPool?.reset(this.el.querySelectorAll(".c-product-card"));
  }

  initResizeObserver() {
    let timer;
    this._resizeHandler = () => {
      clearTimeout(timer);
      timer = setTimeout(() => this.rebuild(), 200);
    };
    window.addEventListener("resize", this._resizeHandler);
  }

  rebuild() {
    this.slider.destroy();

    Array.from(this.list.querySelectorAll("[aria-hidden='true']")).forEach(
      (el) => el.remove()
    );

    fillSlider(this.list);

    this.slider = new KeenSlider(this.list, {
      loop: true,
      slides: {
        perView: "auto",
        spacing: 8,
      },
    });

    this.syncMedia();
  }

  destroy() {
    window.removeEventListener("resize", this._resizeHandler);
    this.slider.destroy();
    this.mediaPool?.destroy();
  }

  initClickableTag() {
    const tagEl = this.el.querySelector("[data-clickable-tag]");
    if (!tagEl) return;

    const words = tagEl.dataset.clickableTagList
      .split(",")
      .map((w) => w.trim());

    let currentIndex = 0;
    let lastRotation = -8; // matches the base span's initial rotation

    const href = tagEl.dataset.clickableTagHref;
    const arrowSvg =
      '<svg viewBox="0 0 63 77" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M28.81 75.15C22.79 68.098 16.426 62.938 9.89 59.67V57.176C16.426 53.908 22.79 48.662 28.81 41.696H33.798C30.96 47.716 28.208 52.36 25.456 55.37H46.096V22.948H52.202V61.476H25.456C28.208 64.486 30.96 69.13 33.798 75.15H28.81Z" fill="currentColor"/><path d="M33.2108 28.4731V22.4731L52.2108 22.4731V28.4731L33.2108 28.4731Z" fill="currentColor"/></svg>';

    tagEl.addEventListener("click", () => {
      if (currentIndex >= words.length - 1) return;

      currentIndex++;

      const rotation = this.randomRotation(lastRotation);
      lastRotation = rotation;

      const isLast = currentIndex >= words.length - 1;
      const el = document.createElement(isLast && href ? "a" : "span");
      if (isLast && href) {
        el.href = href;
      }
      el.dataset.tagIndex = currentIndex;
      el.classList.add("c-free-products-push__tag__vibrate", "is-stacked");
      el.style.setProperty("--rotation", `${rotation}deg`);

      const label = document.createElement("span");
      label.classList.add("c-free-products-push__tag-label");
      label.textContent = words[currentIndex];
      el.appendChild(label);

      if (isLast) {
        const arrow = document.createElement("span");
        arrow.classList.add("c-free-products-push__tag-arrow");
        arrow.innerHTML = arrowSvg;
        el.appendChild(arrow);
      }

      tagEl.appendChild(el);

      tagEl
        .querySelectorAll(".is-vibrating")
        .forEach((v) => v.classList.remove("is-vibrating"));
      el.classList.add("is-vibrating");

      if (isLast) {
        tagEl.classList.add("is-maxed");
      }
    });
  }

  randomRotation(prev) {
    let angle;
    do {
      const magnitude = Math.random() * 9 + 3; // 3–12deg
      const sign = Math.random() < 0.5 ? 1 : -1;
      angle = magnitude * sign;
    } while (Math.abs(angle - prev) < 6);
    return Math.round(angle);
  }
}
